// Icon
import { FiTrash2 } from "react-icons/fi"

export const DeleteButton = ({ onClick }) => (
	<div className="tooltip" data-tip="Delete Data">
		<button className='btn btn-error btn-sm btn-square' onClick={onClick}>
			<FiTrash2 size={14} className="text-white" />
		</button>
	</div>
)